<template>
  <v-dialog :value="value" persistent width="350">
    <v-card>
      <v-toolbar class="accent white--text" flat>
        <v-toolbar-title>Copy Contract</v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="$emit('update:value', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="pa-6 fill">
        <v-form ref="form">
          <v-row dense>
            <v-autocomplete auto-select-first class="mt-7" offset-y
              :menu-props="{ rounded: '', maxHeight: 260 }" dense outlined :items="vendors" item-text="vendor_name"
              item-value="vendor_number" background-color="input"
              :prepend-inner-icon="$auth.isBuyer ? 'mdi-filter-outline' : 'mdi-account-circle'" label="Vendor"
              v-model="vendor" :filter="vendorFilter" :rules="[v => !!v || 'Vendor Required']">
              <template #item="data">
                <v-list-item-content>
                  <v-list-item-title>{{data.item ? data.item.vendor_name : ''}}</v-list-item-title>
                  <v-list-item-subtitle class="text-capitalize">{{data.item ? data.item.vendor_number : ''}}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-row>
          <v-row dense>
            <v-autocomplete :items="storeTypes" :menu-props="{ rounded: '', maxHeight: 260 }"
              background-color="input" dense
              item-text="storeTypeDescription" item-value="storeType" prepend-inner-icon="mdi-store" label="Store Type" outlined
              v-model="storeType" :rules="[v => !!v || 'Store Type Required']"/>
          </v-row>
        </v-form>
      </v-container>
      <v-divider />
      <v-toolbar color="fill" flat>
        <v-spacer />
        <v-btn :loading="loading" @click="copyContract" class="primary white--text" rounded>
          <v-icon left>mdi-content-duplicate</v-icon>Copy
        </v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { displayHelpers } from '@/mixins/display-helpers'

export default {
  name: 'ContractCopy',
  props: {
    value: Boolean,
    contract: Object,
    getContract: Function
  },
  mixins: [displayHelpers],
  data: () => ({
    loading: false,
    selected: [],
    vendor: '',
    storeType: ''
  }),
  computed: {
    ...mapState([
      'storeTypes',
      'addedItems',
      'currentVendor',
      'contractTypes',
      'vendors'
    ])
  },
  created() {
    this.vendor = this.currentVendor.vendor_number
    if (!this.vendors.length) {
      this.$store.dispatch('getVendors', { vendor_numbers: !this.$auth.isBuyer ? this.$auth.vendorNumbers : [] })
    }
  },
  methods: {
    vendorFilter (item, queryText) {
      const name = item.vendor_name.toLowerCase() 
      const number = item.vendor_number.toLowerCase()
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 ||
        number.indexOf(searchText) > -1
    },
    comparator(a, b) {
      return a.storeType === b.storeType
    },
    async copyContract() {
      const valid = this.$refs.form.validate()
      if (valid) {
        this.$emit('update:value', false)
        this.$store.dispatch('setOverlay', { status: 'show', text: 'Copying...' })
        try {
          const contractUUID = await this.getContractUUID()
          await this.saveContractTypes(contractUUID)
          const stores = await this.getStoreList(this.storeType)
          const items = await this.checkForAvailableItems(stores)
          if (items.length > 0) {
            await this.saveItemsToContract(contractUUID, items)
          }
  
          this.$store.dispatch('setSnackbar', {
            status: 'success',
            text: 'Contract Copied'
          })
          this.$router.replace({ query: { id: contractUUID } })
          this.getContract(contractUUID)
        } catch (error) {
          console.log(error)
        } finally {
          this.$store.dispatch('setOverlay', { status: 'hide' })
        }
      } else {
        this.$store.dispatch('setSnackbar', {
            status: 'error',
            text: 'Missing Values'
          })
      }
    },
    async getContractUUID() {
      try {
        const copy = {
          description: `${this.contract.description} (Copy)`,
          store_type: this.storeType,
          vendor_number: this.vendor
        }
        const response = await this.$contracts.createContract(copy)
        return response.data.contract_uuid
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error Creating Contract'
        })
      }
    },
    async saveContractTypes(contractUUID) {
      this.contractTypes.forEach(ct => (ct.contract_uuid = contractUUID))
      try {
        await this.$contracts.saveContractTypes(this.contractTypes)
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error Creating Contract'
        })
      }
    },
    async getStoreList(storeType) {
      try {
        let stores = await this.$stores.getStoresByType(storeType)
        if (stores.data.length > 0) {
          return stores.data.map(s => parseInt(s.StoreNumber))
        }
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error Retrieving Stores'
        })
      }
    },
    async checkForAvailableItems(storeList) {
      if (this.addedItems.length > 0) {
        const newItems = this.addedItems.filter(({item_exists}) => item_exists === false )
        try {
          const { data } = await this.$items.getItemByUPC({
            upc_list: this.addedItems.map(item => item.upc),
            vendor: this.vendor,
            store_list: storeList
          })
          return [...data, ...newItems]
        } catch {
          this.$store.dispatch('setSnackbar', {
            status: 'error',
            text: 'No Available Items'
          })
        }
      }
    },
    async saveItemsToContract(contractUUID, items) {
      console.log(contractUUID, items)
      try {
        await this.$items.saveItems(contractUUID, items)
      } catch {
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: 'Error SAving'
        })
      }
    }
  }
}
</script>
